import React from 'react';
import { Chip } from '@mui/material';
import { AccountBalanceWallet as WalletIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useOutstandingBalance } from '../../contexts/OutstandingBalanceContext';
import { balanceProfilePath, formatMoney } from '../../utils/outstandingBalance';

/** Nav chip showing the signed-in member's overdue balance; links to their profile balance section. */
const OutstandingBalanceBadge = () => {
  const { balance, userTenantId } = useOutstandingBalance();
  const total = balance?.totalOverdueCents || 0;
  const profilePath = balanceProfilePath(userTenantId);

  if (total <= 0 || !profilePath) return null;

  return (
    <Chip
      component={Link}
      to={profilePath}
      clickable
      size="small"
      color="error"
      icon={<WalletIcon />}
      label={formatMoney(total)}
      aria-label={`Overdue balance ${formatMoney(total)}`}
      sx={{ fontWeight: 600 }}
    />
  );
};

export default OutstandingBalanceBadge;
